import { useState } from 'react'
import { Card, Button } from '@arco-design/web-react'
import { useTranslation } from 'react-i18next'
import DeleteAccountModal from './modals/DeleteAccountModal'

interface DangerZoneCardProps {
  runSecure: <T>(fn: () => Promise<T>) => Promise<T>
}

export default function DangerZoneCard({ runSecure }: DangerZoneCardProps) {
  const { t } = useTranslation()
  const [deleteOpen, setDeleteOpen] = useState(false)

  return (
    <>
      <Card className="tt-card !rounded-2xl !border-red-200" title={t('personal.danger.title')}>
        <p className="text-sm text-[var(--console-text-muted)] mb-4">{t('personal.danger.desc')}</p>
        <Button long status="danger" type="outline" onClick={() => setDeleteOpen(true)}>
          {t('personal.danger.deleteAccount')}
        </Button>
      </Card>

      <DeleteAccountModal visible={deleteOpen} onClose={() => setDeleteOpen(false)} runSecure={runSecure} />
    </>
  )
}
